module.exports = __webpack_public_path__ + "static/media/BraceleT12.da71cdb8.JPG";